/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var ExclamationInDiamondSolidIcon = createIcon("ExclamationInDiamondSolidIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#171717';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.393 10.535 13.464.607a2.071 2.071 0 00-2.929 0l-9.928 9.93a2.072 2.072 0 000 2.929l9.928 9.928c.81.808 2.12.808 2.93 0l9.928-9.928a2.072 2.072 0 000-2.93ZM11.034 6.217a1.036 1.036 0 112.072 0v6.215a1.036 1.036 0 11-2.072 0V6.217Zm1.089 11.922h-.029a1.584 1.584 0 01-1.576-1.523 1.527 1.527 0 011.5-1.584h.028a1.582 1.582 0 011.577 1.522 1.528 1.528 0 01-1.5 1.585Z",
    fill: _color
  }));
}, {
  "replaceColor": true
});